"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redeemedAmountGuardManifest = void 0;
const generated_1 = require("../generated");
const guards_1 = require("../guards");
/**
 * The redeemedAmount guard forbids minting when the
 * number of minted NFTs for the entire Candy Machine
 * reaches the configured maximum amount.
 */
exports.redeemedAmountGuardManifest = {
    name: 'redeemedAmount',
    serializer: generated_1.getRedeemedAmountSerializer,
    mintParser: guards_1.noopParser,
    routeParser: guards_1.noopParser,
};
//# sourceMappingURL=redeemedAmount.js.map